// angular import
import { Component, Input } from '@angular/core';
import { NavigationItem } from '../../navigation';
import { animate, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { TfService } from 'src/app/tf/tf-service.service';
import { ConfigurationsService } from '../../../configuration/service/configurations.service';
import { ThemeConfig } from 'src/app/app-config';
@Component({
  selector: 'app-nav-collapse',
  templateUrl: './nav-collapse.component.html',
  styleUrls: ['./nav-collapse.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', display: 'block' }),
        animate('250ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [animate('250ms ease-in', style({ transform: 'translateY(-100%)' }))])
    ])
  ]
})
export class NavCollapseComponent {
  // public props
  @Input() item: NavigationItem;
  visible;
  config: any;
  themeLayout: string;
  langset;
  themeConfig
  isAdmin = false;
  user: string;
  // constructor
  constructor(
    // public languageService: LanguageService,
    public translate: TranslateService,
    private ConfigurationsService: ConfigurationsService,
     private tfService: TfService
  ) {
    this.ConfigurationsService.getConfig().subscribe((res) => {
      this.themeConfig = res;
      this.config = this.themeConfig
      this.visible = false;
      this.config = ThemeConfig;
      this.themeLayout = this.themeConfig.layout;
    }
    );
    // this.langset = localStorage.getItem("lang")
    // this.languageService.setLanguage(this.langset);
    this.setUserTypeBasedOnToken();
  }
  // function manages user authentication and authorization
  setUserTypeBasedOnToken(): void {

    // const token = this.tfService.getToken();
    const userGroups = localStorage.getItem('userGroup');
    console.log('role.item', userGroups);

    // Check if the user is in the usergroup
    if (userGroups.includes('admin')) {
      this.user = 'admin';
    } else {
      this.user = 'contact';
    }
    console.log('role.user', this.user);

  }
  // public method
  navCollapse(e) {
    this.visible = !this.visible;
    let parent = e.target;
    if (this.themeLayout === 'vertical') {
      parent = parent.parentElement;
    }
    parent.classList.toggle('pcoded-trigger');
    do {
      // Move up to the parent element in each iteration
      parent = parent.parentElement;
      if (parent && parent.classList.contains('pcoded-hasmenu')) {
        if (!parent.classList.contains('pcoded-trigger')) {
          parent.classList.add('pcoded-trigger');
        }
      }
    } while (parent);
  }
}
